import React, { useState, useEffect } from "react"
import { isSmallScreen, locale } from "@albelli/photoselector"
import { PhotoOrganiserPages } from "../PhotoOrganiser"
import sortingIcon from "@albelli/photoselector/lib/ImagePicker/Graphic/sorting-icon.svg"

interface Page {
  page: number
  text: string
}

interface PhotoOrganiserNavigationProps {
  currentPage: PhotoOrganiserPages
  navigateTo: (page: PhotoOrganiserPages) => void
}

const getPages = (): Page[] => {
  const text = locale.get().photoorganiser.navigation
  return [
    { page: PhotoOrganiserPages.Years, text: text.photos },
    { page: PhotoOrganiserPages.Events, text: text.events },
    { page: PhotoOrganiserPages.Collections, text: text.collections },
    { page: PhotoOrganiserPages.Favorites, text: text.favorites },
    { page: PhotoOrganiserPages.LatestUploads, text: text.latestuploads }
  ]
}

const getClass = (pageId: PhotoOrganiserPages, currentPage: PhotoOrganiserPages) =>
  pageId === currentPage ? "photoselector-photoorganiser-navigation-selected" : undefined

const PhotoOrganiserNavigation: React.FunctionComponent<PhotoOrganiserNavigationProps> = ({ currentPage, navigateTo }) => {
  const [isMobile, setIsMobile] = useState<boolean>(isSmallScreen())
  const [showNavigation, setShowNavigation] = useState<boolean>(false)
  const handleResize = () => setIsMobile(isSmallScreen())

  useEffect(() => {
    window.addEventListener("resize", handleResize)
    return () => {
      window.removeEventListener("resize", handleResize)
    }
  }, [])

  useEffect(() => {
    const isNavigatingPage = !!getPages().find((page) => page.page === currentPage)
    setShowNavigation(isNavigatingPage)
  }, [currentPage])

  return showNavigation ? (
    <div className="photoselector-photoorganiser-navigation" data-tam="photoorganiser-navigation">
      {isMobile ? (
        <PhotoOrganiserMobileNavigation currentPage={currentPage} navigateTo={navigateTo} />
      ) : (
        <PhotoOrganiserNavigationList currentPage={currentPage} navigateTo={navigateTo} />
      )}
    </div>
  ) : null
}

const PhotoOrganiserNavigationList: React.FunctionComponent<PhotoOrganiserNavigationProps> = ({ currentPage, navigateTo }) => {
  return (
    <ul>
      {getPages().map((page) => (
        <li key={page.page} className={getClass(page.page, currentPage)} onClick={() => navigateTo(page.page)} data-tam="photoorganiser-tab">
          {page.text}
        </li>
      ))}
    </ul>
  )
}

const PhotoOrganiserMobileNavigation: React.FunctionComponent<PhotoOrganiserNavigationProps> = ({ currentPage, navigateTo }) => {
  const getSelectedPage = () => getPages().filter((page) => page.page === currentPage)[0]
  const [isExpanded, setIsExpanded] = useState<boolean>(false)
  const [selectedPage, setSepectedPage] = useState<Page>(getSelectedPage())

  useEffect(() => {
    setSepectedPage(getSelectedPage())
  }, [currentPage])

  return (
    <div className="photoselector-photoorganiser-app-dropdown" onClick={() => setIsExpanded(!isExpanded)}>
      <div className="photoselector-photoorganiser-app-selected-tab">
        <span>{selectedPage.text}</span>
        <img className="sort-icon" src={sortingIcon} />
      </div>
      {isExpanded ? <PhotoOrganiserNavigationList currentPage={currentPage} navigateTo={navigateTo} /> : null}
      {isExpanded ? <div className="overlay"></div> : null}
    </div>
  )
}

export default PhotoOrganiserNavigation
